import { ReferralControllerApi, UpdateReferral } from "../services";
import { getConfigObject, useMutationWithLoading } from "../utils/utils";

/**
 *
 * @author Atish Bagate
 */

interface Params {
  updateReferral: UpdateReferral;
  xTENANTID?: string;
}

export const useUpdateReferralStatus = () =>
  useMutationWithLoading(async (params: Params) =>
    new ReferralControllerApi(getConfigObject()).updateReferralStatus(
      params.updateReferral,
      params.xTENANTID
    )
  );
